// scripts
import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './filters';

// styles
import './assets/main.scss';

// options
Vue.use(VueFormGenerator);
Vue.config.productionTip = false;

const { lang } = document.documentElement;
i18n.locale = lang;

const root = new Vue({
  data: { loading: false, app_data: window.app_data },
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');


if (window.BX24) {
  window.BX24.ready(() => {
    window.BX24.init(() => {
      const height = 950;
      window.BX24.resizeWindow(
        document.body.clientWidth,
        height,
      );
    });
  });
}

router.beforeEach((to, from, next) => {
  root.loading = true;
  next();
});

router.afterEach((to, from) => {
  root.loading = false;

  if (window.BX24) {
    window.BX24.ready(() => {
      window.BX24.init(() => {
        let height = document.getElementById('app').clientHeight;
        if (height < 750) {
          height = 750;
        }
        window.BX24.resizeWindow(
          document.body.clientWidth,
          height + 100,
        );
      });
    });
  }
});
